import { StarsInfo } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Link from '@swf/components/Link/Link';
import Translation from '@swf/components/Translation/Translation';
import { call } from '@swf/core/api/embedded';
import SuccessIcon from '@swf/core/assets/icons/success.svg';
import { Site } from '@swf/core/enums';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import {
  TXTCLI_OtherwiseX_your_account_will_b_ELL_1,
  TXTCLI_Please_note_that_in_accordance_ELL,
  TXTCLI_Thank_youX_your_address_has_be_ELL,
  TXTCLI_You_must_verify_your_address_b_ELL_3,
  TXTCLI_You_will_not_be_able_to_make_w_ELL,
  TXTWCL_Once_we_receive_your_IDX_we_wi_ELL,
  TXTWCL_Our_system_shows_that_you_have_ELL,
  TXTWCL_To_finalize_your_registrationX_ELL_1,
  TXTWCL_Verify_my_account,
  TXTWCL_You_will_be_prompted_to_do_so__ELL_1,
  TXTWCL_Your_changes_have_been_saved_s_ELL
} from './SuccessResponseMessage.messages.json';
import styles from './SuccessResponseMessage.scss';

export const SuccessResponseMessage: React.FC = () => {
  const site = useSelector(select.cms.getSiteId);
  const ageVerified = useSelector(select.account.isAgeVerified);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const { modal } = useDispatch<Dispatch>();

  const openVerifyAccount = () => {
    isEmbedded
      ? call(['app', 'execute'], 'docverify')
      : modal.replace([{ path: '/auth/docverify' }]);
  };

  return (
    <StarsInfo type="confirmation" className={styles.message}>
      {site === Site.FR ? (
        <>
          <SuccessIcon className={styles.successIcon} />
          <div className={styles.hasTitle}>
            <Translation tagName="p" {...TXTCLI_Thank_youX_your_address_has_be_ELL} />
            {!ageVerified && (
              <>
                <Translation tagName="p" {...TXTWCL_Our_system_shows_that_you_have_ELL} />
                <Translation tagName="p" {...TXTWCL_You_will_be_prompted_to_do_so__ELL_1} />
                <p>
                  <Translation {...TXTWCL_Once_we_receive_your_IDX_we_wi_ELL} />{' '}
                  <Translation {...TXTWCL_To_finalize_your_registrationX_ELL_1} />
                </p>
              </>
            )}
            {ageVerified && (
              <>
                <Translation tagName="p" {...TXTCLI_Please_note_that_in_accordance_ELL} />
                <p>
                  <Translation {...TXTCLI_You_must_verify_your_address_b_ELL_3} />{' '}
                  <Translation {...TXTCLI_OtherwiseX_your_account_will_b_ELL_1} />
                </p>
                <Translation tagName="p" {...TXTCLI_You_will_not_be_able_to_make_w_ELL} />
              </>
            )}
            <Link onClick={openVerifyAccount}>
              <Translation {...TXTWCL_Verify_my_account} />
            </Link>
          </div>
        </>
      ) : (
        <Translation {...TXTWCL_Your_changes_have_been_saved_s_ELL} />
      )}
    </StarsInfo>
  );
};

export default SuccessResponseMessage;
